const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Generate or retrieve session ID for anonymous users
function getSessionId() {
  let sessionId = localStorage.getItem('gameSessionId');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem('gameSessionId', sessionId);
  }
  return sessionId;
}

async function apiRequest(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const { headers: customHeaders, ...restOptions } = options;
  
  const config = {
    ...restOptions,
    headers: {
      'Content-Type': 'application/json',
      ...customHeaders
    }
  };
  
  // Add auth token if available
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  const response = await fetch(url, config);
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  
  return response.json();
}

export const api = {
  // Puzzles
  getPuzzles: () => apiRequest('/puzzles'),
  getPuzzle: (slug) => apiRequest(`/puzzles/${slug}`),
  submitGuess: (slug, answer) => apiRequest(`/puzzles/${slug}/guess`, {
    method: 'POST',
    body: JSON.stringify({ answer })
  }),
  
  // Auth
  register: (email, password, displayName) => apiRequest('/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password, displayName })
  }),
  googleAuth: (idToken) => apiRequest('/auth/google', {
    method: 'POST',
    body: JSON.stringify({ idToken })
  }),
  verifyToken: (idToken) => apiRequest('/auth/verify', {
    method: 'POST',
    body: JSON.stringify({ idToken })
  }),
  
  // User
  getProfile: () => apiRequest('/users/me'),
  updateProfile: (data) => apiRequest('/users/me', {
    method: 'PUT',
    body: JSON.stringify(data)
  }),
  getSolves: () => apiRequest('/users/me/solves'),
  getGuesses: (puzzleId) => apiRequest(`/users/me/guesses/${puzzleId}`),
  
  // Games - Lobbies
  createLobby: (gameType) => apiRequest('/games/lobbies', {
    method: 'POST',
    body: JSON.stringify({ gameType }),
    headers: { 'X-Session-Id': getSessionId() }
  }),
  joinLobbyByCode: (code) => apiRequest('/games/lobbies/join', {
    method: 'POST',
    body: JSON.stringify({ code }),
    headers: { 'X-Session-Id': getSessionId() }
  }),
  getLobby: (lobbyId) => apiRequest(`/games/lobbies/${lobbyId}`, {
    headers: { 'X-Session-Id': getSessionId() }
  }),
  startGame: (lobbyId) => apiRequest(`/games/lobbies/${lobbyId}/start`, {
    method: 'POST',
    headers: { 'X-Session-Id': getSessionId() }
  }),
  
  // Games - Game State
  getGameState: (gameId) => apiRequest(`/games/${gameId}`, {
    headers: { 'X-Session-Id': getSessionId() }
  }),
  submitMove: (gameId, move) => apiRequest(`/games/${gameId}/move`, {
    method: 'POST',
    body: JSON.stringify(move),
    headers: { 'X-Session-Id': getSessionId() }
  })
};

export { getSessionId };
export default api;
